import { makeStyles } from '@material-ui/core'
import {
  Star as StarIcon,
  StarOutline as StarOutlineIcon,
} from '@material-ui/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import clsx from 'clsx'
import React from 'react'

import { useActionRunner } from 'src/modules/notification'
import { Button } from 'src/modules/ui'

import { useRecipes } from '../hooks'

const useStyles = makeStyles(theme => ({
  actions: {
    '& > *': {
      marginBottom: theme.spacing(0.5),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      '&:last-child': {
        marginRight: theme.spacing(0),
      },
    },
  },
}))

const RecipeActions = ({
  className,
  onClick,
  purchasingEnvironment,
  ...recipe
}) => {
  const { id } = recipe

  const classes = useStyles()
  const {
    addToEnvironment,
    removeFromEnvironment,
    fetchRecipes,
    categoryFilterChoices,
    menuFilterChoices,
  } = useRecipes()

  const [doAddToEnvironment, isAdding] = useActionRunner(addToEnvironment)
  const [doRemoveFromEnvironment, isRemoving] = useActionRunner(
    removeFromEnvironment
  )
  const [doFetchRecipes] = useActionRunner(fetchRecipes)

  const addToMenu = async body => {
    const result = await doAddToEnvironment(body)
    try {
      unwrapResult(result)
      // TODO: Bubble this up to the parent component
      doFetchRecipes({
        purchasingEnvironment,
        categoryFilterChoices,
        menuFilterChoices,
      })
    } catch (error) {
      console.error(error)
    }
  }

  const removeFromMenu = async recipe => {
    const result = await doRemoveFromEnvironment(
      recipe.currentRecipeEnvironmentId
    )
    try {
      unwrapResult(result)
      // TODO: Bubble this up to the parent component
      doFetchRecipes({
        purchasingEnvironment,
        categoryFilterChoices,
        menuFilterChoices,
      })
    } catch (error) {
      console.error(error)
    }
  }

  const preventDefault =
    fn =>
    (event, ...args) => {
      event.stopPropagation()
      event.preventDefault()
      return fn && fn(event, ...args)
    }

  return (
    <div className={clsx(classes.actions, className)}>
      {purchasingEnvironment &&
        (recipe.isOnMenu ? (
          <Button
            color="secondary"
            onClick={preventDefault(() => {
              removeFromMenu(recipe)
            })}
            isLoading={isRemoving}
            startIcon={<StarIcon />}
            size="small"
          >
            On Menu
          </Button>
        ) : (
          <Button
            color="primary"
            onClick={preventDefault(() =>
              addToMenu({
                recipeId: id,
                environmentId: purchasingEnvironment,
              })
            )}
            isLoading={isAdding}
            startIcon={<StarOutlineIcon />}
            size="small"
          >
            Off Menu
          </Button>
        ))}
    </div>
  )
}

export default RecipeActions
